import { GoogleAuthProvider, getAuth, onAuthStateChanged, signInWithPopup} from "firebase/auth";
import {Button} from "../components/common/Button";
import {useUserContext} from "../providers/UserContext";
import {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {useInboxContext} from "../providers/InboxProvider";
import {useChatListContext} from "../providers/ChatListProvider";
import {getItem, removeAll, setItem} from "../lib/localStorage";
import {UploadImages} from "../lib/hooks/UploadImages";
import {Wordmark} from "../components/illustrations/wordmark";
import {Login as LoginIllustration} from "../components/illustrations/login";
export const Login = ({}: {}) => {
  const provider = new GoogleAuthProvider();
  const { setUser, setActiveChatId } = useUserContext();
  const { setInboxVisible } = useInboxContext();
  const navigate = useNavigate();
  const { setChatListVisible } = useChatListContext();
  setChatListVisible(false);
  setActiveChatId("");
  const auth = getAuth();
  auth.languageCode = 'en';
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        await setUser(user);
        if (getItem('activeUserId') !== user.uid) {
          removeAll();
          setItem('activeUserId', user.uid);
        }
        navigate('/inbox');
        setTimeout(() => {
          setInboxVisible(true);
        }, 1000);
      }
    });
  }, []);


  const startLogin = () => {
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    removeAll();
    signInWithPopup(auth, provider)
  }

  return (
    <div className={"bg-gray-10 w-full h-full flex justify-center items-center"}>
      <div className="center p-4 py-10 lg:p-10 bg-white shadow-elevation-3 flex flex-col lg:gap-20 lg:flex-row max-w-[96vw] justify-center items-center lg:justify-between">
        <div className={"flex items-center w-[297px] max-w-[96%]"}>
          <div className={"inline-flex flex-col items-center lg:items-start gap-4 w-full"}>
            <div className={"w-[130px]"}>
              <Wordmark/>
            </div>
            <span className={"font-style-headline-3 !font-[400]"}>Let’s get you ready</span>
            <div className="max-w-full flex lg:hidden">
              <LoginIllustration/>
            </div>
            <button onClick={startLogin}
                    className={"border border-gray-1 rounded-md flex gap-2 p-2 lg:p-4 lg:font-style-body-md items-center justify-center lg:justify-start w-full hover:bg-gray-10"}>
              <img src="/google.svg"/>
              Continue with Google
            </button>
          </div>
        </div>
        <div className="max-w-full hidden lg:flex">
          <LoginIllustration />
        </div>
      </div>
    </div>
  )
}